import api from "@/api/statistics/statistics";

const getDashBoardStatistics = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getDashBoardStatistics(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getCapacityStatistics = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getCapacityStatistics(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const exportTable = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .exportTable(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getSalesStatistic = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getSalesStatistic(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });


export default {
  getDashBoardStatistics,
  getCapacityStatistics,
  exportTable,
  getSalesStatistic,
};
